import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import en from "./locales/en/translation.json"
import de from "./locales/de/translation.json"
import deSIE from "./locales/de-SIE/translation.json"
import deDU from "./locales/de-DU/translation.json"

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        de: { translation: de },
        "de-SIE": { translation: deSIE },
        "de-DU": { translation: deDU },
    },
    supportedLngs: ["en", "de", "de-SIE", "de-DU"],
    fallbackLng: {
        "de-SIE": ["de", "en"],
        "de-DU": ["de", "en"],
        default: ["en"],
    } as any,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
})

export default i18n
